import KarteTracker from '../../lib/KarteTracker';

document.addEventListener('DOMContentLoaded', () => {
  const choosePlan = document.querySelector<HTMLElement>('#choose-plan');
  const visible: boolean = !!(
    choosePlan &&
    (choosePlan.offsetWidth ||
      choosePlan.offsetHeight ||
      choosePlan.getClientRects().length)
  );
  if (!visible) {
    return;
  }

  const trackingDataParams = document.querySelector<HTMLElement>(
    '#tracking-data-params',
  );
  if (!trackingDataParams) {
    return;
  }

  const context = trackingDataParams.dataset.context;

  // Don't send cv_b2c_trial if in "upgrade" context
  // https://github.com/quipper/aya-issues/issues/72794#issuecomment-1736553359
  if (context !== 'upgrade') {
    const karteTracker = new KarteTracker();
    karteTracker.trackConversion('cv_b2c_trial');
  }
});
